import { apiAgent } from "../../../axiosConfig"

export const fetchProspectArticles = (url_params, data_params) => {
    return apiAgent({
        method: "get",
        url:  `/prospect_articles/${url_params.prospect_id}`,
        params: {}
    })
}